import { isHoneycombShadowSize } from '../../utils';
import { HoneycombThemeBase, ShadowValue } from '../types';

export function resolveShadowValue(theme: HoneycombThemeBase) {
    return (value: ShadowValue): string => {
        if (value && isHoneycombShadowSize(value)) {
            return theme.shadows[value] as string;
        }
        return typeof value === 'string' ? value : (theme.shadows.none as string);
    };
}
